import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SessionService } from '../../providers/session.service';
import { EntryBuilderService } from '../../providers/entry-builder.service';
import { HorseShowService } from '../../providers/horse-show.service';
import { AccessCodeService } from '../../providers/access-code.service';
import { Horse_show } from '../../models/horse_show';

import { User } from '../../models/user';
import { faSpinner, faUser, faPlus } from '@fortawesome/fontawesome-pro-regular';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

import { ModalEnterAccessCodeComponent } from '../../components/modal-enter-access-code/modal-enter-access-code.component';

import { faHorseHead, faPlusCircle, faHomeAlt, faMapMarked, faAddressCard, faPhoneOffice, faHotel, faPlaneArrival, faLock } from '@fortawesome/pro-regular-svg-icons';

import * as dayjs from 'dayjs';


@Component({
  standalone: false,
  selector: 'app-enter-horse-show-landing',
  templateUrl: './enter-horse-show-landing.component.html',
styleUrls:  ['./enter-horse-show-landing.component.css']
})
export class EnterHorseShowLandingComponent extends SmsAbstractAppPage implements OnInit {

   navigation_in_progress: boolean = false;
   faSpinner = faSpinner;
   faUser = faUser;
   faPlusCircle = faPlusCircle;
   faHorseHead = faHorseHead;
   faHomeAlt = faHomeAlt;
   faMapMarked = faMapMarked;
   faAddressCard = faAddressCard;
   faPhoneOffice = faPhoneOffice;
   faHotel = faHotel;
   faPlaneArrival = faPlaneArrival;
   faLock = faLock;

   active: boolean = false;

   horse_show: Horse_show = new Horse_show({});

  constructor(private route: ActivatedRoute,
    private entryBuilderService: EntryBuilderService,
    private horseShowService: HorseShowService,
    private accessCodeService: AccessCodeService,
    private router: Router,
    private modal: NgbModal) {
    super();
  }

  ngOnInit(): void {

    this.route.params.subscribe(params => {

          if(params['horse_show_id']){

            this.horseShowService.get(params['horse_show_id']).then(horse_show => {
              this.horse_show = horse_show;
            }).catch(error => {
              this.handleError(error);
            });
      }
    });

  }

  handleCreateEntry(horse_show: Horse_show){
    this.entryBuilderService.reset();
    this.navigation_in_progress = true;
    this.router.navigate(['create-horse-show-entry/add-horse-and-people/' + horse_show.id]);
  }

  handleNominateRider(horse_show: Horse_show){
    this.entryBuilderService.reset();
    this.navigation_in_progress = true;
    this.router.navigate(['nominate-rider/add-rider/' + horse_show.id]);
  }

  handleCreateBarnAccount(horse_show: Horse_show){
    this.entryBuilderService.reset();
    this.navigation_in_progress = true;
    this.router.navigate(['create-barn-account/add-person/' + horse_show.id]);
  }

  handleDisplayOrganizerInformation(organizer_id: string){
   this.navigation_in_progress = true;
    this.router.navigate(['organizer-information/' + organizer_id]);
  }

  public getFullCountryName(country_code: string){
    switch(country_code) {
      case 'USA': return "United States";
      case "CAN": return "Canada";
      default: return "Canada";
    }
  }

  private handleEnterAccessCode(horse_show: Horse_show){
      let modal_ref_access = this.modal.open(ModalEnterAccessCodeComponent, {size: 'lg'});

      modal_ref_access.componentInstance.horse_show_id = horse_show.id;

      modal_ref_access.componentInstance.horse_show_unlocked$.subscribe(responding_id => {

        if(responding_id == horse_show.id){
          horse_show.restricted_event_unlocked = true;
          modal_ref_access.close();
        }
      },
        error => {
          this.handleError(error);
        });

  }


}
